/**
 * ShowMoreSpecialization
 * ======================================
 */

 const ELEMENTS = '.js-ShowMoreSpecialization'
 const TOGGLE_CLASS = 'is-open'
 const PARENT = '.box-nav'

 class ShowMoreSpecialization {
   constructor() {
    this.elements = document.querySelectorAll(ELEMENTS);

    if (!this.elements) {
      return false;
    }

    this.elements.forEach((el) => {
      el.addEventListener('click', this.show)
    });
   }

   show = (e) => {
    const el = e.currentTarget;
    const target = el.closest(PARENT);
    const classes = target.classList

    classes.add(TOGGLE_CLASS)
    e.preventDefault();
  };
 }

 new ShowMoreSpecialization()
